import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@artosera/ui';
import { partiesLocales } from '@artosera/shared';
import { useCreneauxRdv, type TypeRdv } from '../../api/priseRendezVous.js';
import { useShellContext } from '../shell/context.js';
import { ErreurRdv } from './ErreurRdv.js';
import { dateHeureRdv, periodeRdv } from './temps.js';
import styles from './RendezVous.module.css';

export function ApercuCreneaux({ types, fuseau }: { types: TypeRdv[]; fuseau: string }) {
  const { galerieSlug } = useShellContext();
  const { t, i18n } = useTranslation(['regie', 'commun']);
  const [selection, setSelection] = useState('');
  const [date] = useState(() => partiesLocales(new Date(), fuseau).date);
  const disponibles = types.filter((v) => !v.archiveLe);
  const id = disponibles.find((v) => v.id === selection)?.id ?? disponibles[0]?.id ?? '';
  const { du, au } = periodeRdv(date, 14, fuseau);
  const apercu = useCreneauxRdv(galerieSlug, id, du, au);
  const langue = i18n.language === 'en' ? 'en' : 'fr';
  return (
    <section className={styles.bloc} aria-label={t('regie:priseRendezVous.apercu')}>
      <h2>{t('regie:priseRendezVous.apercu')}</h2>
      <p>{fuseau}</p>
      <label className={styles.champ}>
        {t('regie:priseRendezVous.typeApercu')}
        <Select
          value={id}
          onValueChange={setSelection}
          options={disponibles.map((v) => ({ value: v.id, label: v.titre[langue] || v.titre.fr }))}
        />
      </label>
      {apercu.isLoading ? <p role="status">{t('commun:chargement')}</p> : null}
      <ErreurRdv erreur={apercu.error} />
      {!apercu.isLoading && !apercu.error && !apercu.data?.creneaux.length ? (
        <p>{t('regie:priseRendezVous.aucunCreneau')}</p>
      ) : null}
      <ul className={styles.liste}>
        {apercu.data?.creneaux.map((c) => (
          <li key={c.debut}>
            {dateHeureRdv(c.debut, fuseau)} – {partiesLocales(new Date(c.fin), fuseau).heure}
          </li>
        ))}
      </ul>
    </section>
  );
}
